import { DateTime } from 'luxon'
import { Trans } from 'react-i18next'

import translationKeys from '@translationKeys'

import { dateTimeFormats } from '@theme/variables'

import { ProfileDateTitle } from '../index.styles'
import { CellInfo } from '../types'

export const UpdatedAtCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { hasAccessToAlerts },
  } = info
  const isUpdated = hasAccessToAlerts && (profileData.isProfileUpdated || !!profileData.profileAlert?.hasNewActivity)

  return (
    <div>
      {isUpdated ? (
        <ProfileDateTitle>
          <Trans>{translationKeys.UPDATED}</Trans>
        </ProfileDateTitle>
      ) : null}
      {DateTime.fromISO(profileData.profileUpdatedDate).toFormat(dateTimeFormats.eventDateFormat)}
    </div>
  )
}
